'use strict';

var Utilities = {
	mobile: function() {
		var check = false;
		if (/Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			check = true;
		} else {
			check = false;
		}
		return check;
	},

	trimSpace: function(x) {
		var emptySpace = / /g;
		var trimAfter = x.replace(emptySpace, "");
		return (trimAfter);
	},

	NumberValidate: function(incomingString, defaultValue) {
		if (this.trimSpace(incomingString).length === 0 || incomingString.search(/[^0-9]/g) != -1) {
			return false;
		} else {
			return true;
		}
	},

	TextValidateRu: function(incomingString, defaultValue) {
		if (this.trimSpace(incomingString).length === 0 || incomingString.search(/[^а-яА-ЯёЁ]/g) != -1) {
			return false;
		} else {

			return true;
		}
	},

	TextValidateEng: function(incomingString, defaultValue) {
		if (this.trimSpace(incomingString).length === 0 || incomingString.search(/[^a-z A-Z]/g) != -1) {
			return false;
		} else {

			return true;
		}
	},

	EmailValidate: function(incomingString, defaultValue) {
		var str = incomingString.trim();
		var regexp = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
		if (this.trimSpace(incomingString).length === 0 || !regexp.test(str)) {
			return false;
		} else {
			return true;
		}
	}
};

var scrollToElement = {
	toId: function(id) {
		setTimeout(function() {
			$('html, body').animate({
				scrollTop: parseInt($(id).offset().top)
			}, 1000);
		}, 200);
	},

	init: function() {
		var self = this;

		$(document).on('click', '.js-scrollTo', function(e) {
			var $this = $(e.currentTarget);
			var group = $this.closest('.js-scrollTo-group');
			if ($this.attr('href')) {
				e.preventDefault();
			}
			if (group.length) {
				group.find('.active').removeClass('active');
				$this.parent().addClass('active');
			}
			self.toId($this.data('scroll'));
		});
	}
};

var stepsSlider = {
	slider: $('.js-steps-list'),
	sliderSettings: function() {
		return {
			dots: true,
			infinite: true,
			speed: 600,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			cssEase: 'ease',
			focusOnSelect: true
		}
	},
	init: function() {
		var self = this;

		if (self.slider.length) {
			if ($(window).width() <= 767) {
				self.slider.slick(self.sliderSettings());
			}

			$(window).on('resize', function() {
				if ($(window).width() <= 767) {
					if (!self.slider.hasClass('slick-initialized')) {
						self.slider.slick(self.sliderSettings());
					}
				} else {
					if (self.slider.hasClass('slick-initialized')) {
						self.slider.slick('unslick');
					}
				}
			})
		}
	}
};

var rewardSlider = {
	slider: $('.js-reward-list'),
	sliderSettings: function() {
		return {
			dots: true,
			infinite: true,
			speed: 600,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			cssEase: 'ease',
			focusOnSelect: true
		}
	},
	init: function() {
		var self = this;

		if (self.slider.length) {
			if ($(window).width() <= 767) {
				self.slider.slick(self.sliderSettings());
			}

			$(window).on('resize', function() {
				if ($(window).width() <= 767) {
					if (!self.slider.hasClass('slick-initialized')) {
						self.slider.slick(self.sliderSettings());
					}
				} else {
					if (self.slider.hasClass('slick-initialized')) {
						self.slider.slick('unslick');
					}
				}
			})
		}
	}
};

var frame = {
	player: null,
	btnPlay: null,
	btnMute: null,
	play: function() {
		var self = this;
		var videoTag = self.player.find('video');

		if (videoTag.length) {
			var video = videoTag.get(0);

			video.volume = 0.1;
			video.onended = function(e) {
				this.currentTime = 0;
				this.play();
			};

			self.btnMute.on('click', function(e) {
				var $this = $(e.currentTarget);

				if ($this.hasClass('active')) {
					video.muted = true;
					$this.removeClass('active');
				} else {
					video.muted = false;
					$this.addClass('active');
				}

				alert(video.muted);
			});

			self.btnPlay.on('click', function(e) {
				var $this = $(e.currentTarget);

				if ($this.hasClass('active')) {
					video.pause();
					$this.removeClass('active');
				} else {
					video.play();
					$this.addClass('active');
				}
			});

			$(window).on('load', function() {
				if (!Utilities.mobile()) {
					self.btnPlay.trigger('click');
				}
			});
		}
	},
	createBg: function() {
		var self = this;
		var embed = false;

		self.player.find('.js-rimmel-out-frame-embed').empty();
		self.player.find('.js-rimmel-out-frame-embed').each(function() {
			var $this = $(this);
			var video = $this.data('video');
			var poster = $this.data('poster');
			var img = $this.data('img');

			if (typeof(video) !== 'undefined' && $(window).width() >= 768) {
				var vhtml = '<video loop muted poster="' + poster + '">';
				vhtml += '<source src="' + video + '.mp4" type="video/mp4">';
				vhtml += '<source src="' + video + '.webm" type="video/webm">';
				vhtml += '</video>';
				$this.append(vhtml);
			}

			if (typeof(img) !== 'undefined' && $(window).width() < 768) {
				$this.append('<img src="' + img + '">');
			}

			embed = true;
		});

		return embed;
	},

	init: function() {
		var self = this;
		var $this = $('.js-rimmel-out-frame');
		var embed;

		if ($this.length) {
			self.player = $this;
			self.btnPlay = $this.find('.js-rimmel-out-frame-play');
			self.btnMute = $this.find('.js-rimmel-out-frame-mute');
			embed = self.createBg();

			if (Utilities.mobile()) {
				self.btnMute.hide();
			}

			if (embed) {
				self.play();
			}

			var timeout = false;
			self.player.on('mousemove', function(e) {
				clearTimeout(timeout);
				if (!self.player.hasClass('is-active')) {
					self.player.addClass('is-active');
				}
				timeout = setTimeout(function() {
					self.player.removeClass('is-active');
				}, 5000);
			});
		}
	}
};

var popupVideoSlider = {
	parent: $('.js-rimmel-out-popupvideo'),
	slider: $('.js-rimmel-out-popupvideo-list'),
	sliderSettings: function() {
		return {
			dots: false,
			infinite: true,
			speed: 600,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			cssEase: 'ease-out',
			focusOnSelect: true,
			fade: true,
			responsive: [{
				breakpoint: 768,
				settings: {
					arrows: false
				}
			}]
		}
	},
	createBg: function() {
		var self = this;

		self.parent.find('.rimmel-out-popup__bg').empty();

		self.slider.find('.js-rimmel-out-popupvideo-embed').each(function() {
			var $this = $(this);
			var img = $this.data('img');
			var imgSmall = $this.data('img-small');

			if (typeof(img) != 'undefined' && $(window).width() > 768) {
				self.parent.find('.rimmel-out-popup__bg').append('<div class="rimmel-out-popup__bg-img"><img src="' + img + '"></div>');
			}

			if (typeof(imgSmall) != 'undefined' && $(window).width() <= 768) {
				self.parent.find('.rimmel-out-popup__bg').append('<div class="rimmel-out-popup__bg-img"><img src="' + imgSmall + '"></div>');
			}
		});
	},
	video: function() {
		var self = this;
		var videoTag = self.parent.find('.js-embed-media video');

		if (videoTag.length > 0 && typeof($.fn.mediaelementplayer) != "undefined") {
			videoTag.each(function() {
				var $this = $(this);
				$this.mediaelementplayer({
					loop: false,
					defaultVideoWidth: 723,
					defaultVideoHeight: 405,
					videoWidth: -1,
					videoHeight: -1,
					startVolume: 0.5,
					enableAutosize: true,
					alwaysShowControls: true,
					// iPadUseNativeControls: true
				});
			});
		}
	},
	init: function(id) {
		var self = this;
		var args = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
		var triggerOpen = false;

		self.createBg();
		self.video();

		if (self.slider.length) {
			if (!self.slider.hasClass('slick-initialized')) {
				self.slider.on('init', function(event, slick) {
					for (var i = 0; i < slick.$slides.length; i++) {
						if ($(slick.$slides[i]).hasClass('slick-current')) {
							self.parent.find('.rimmel-out-popup__bg').children().eq(i).addClass('is-active');
						}
					}

				}).on('beforeChange', function(event, slick, slide, nextSlide) {
					self.parent.find('.rimmel-out-popup__bg').children().removeClass('is-active').eq(nextSlide).addClass('is-active');

					if (!triggerOpen && $(slick.$slides[slide]).find('video').length) {
						$(slick.$slides[slide]).find('video')[0].pause();
					}
				}).on('afterChange', function(event, slick, currentSlide) {
					triggerOpen = false;
				}).on('breakpoint', function(slick, event, breakpoint) {
					if (breakpoint == 768) {
						self.createBg();
					} else {
						self.createBg();
					}
				}).slick(self.sliderSettings());

				if (args > 0) {
					triggerOpen = true;
					self.slider.slick('slickGoTo', args, true);
				}
			}
		}
	},
	destroy: function() {
		var self = this;
		if (self.slider.hasClass('slick-initialized')) {
			self.slider.slick('unslick');
			self.slider.off('init');
			self.slider.off('beforeChange');
			self.slider.off('afterChange');
			self.parent.find('.rimmel-out-popup__bg').empty();
		}
	}
};

var popupResultSlider = {
	parent: $('.js-rimmel-out-popupresult'),
	slider: $('.js-rimmel-out-popupresult-list'),
	sliderSettings: function() {
		return {
			dots: false,
			infinite: true,
			speed: 600,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			cssEase: 'ease-out',
			focusOnSelect: true,
			responsive: [{
				breakpoint: 768,
				settings: {
					arrows: false
				}
			}]
		}
	},
	destroy: function() {
		var self = this;
		if (self.slider.hasClass('slick-initialized')) {
			self.slider.slick('unslick');
		}
	},
	init: function() {
		var self = this;
		var args = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;

		if (self.slider.length) {
			if (!self.slider.hasClass('slick-initialized')) {
				self.slider.slick(self.sliderSettings());

				if (args > 0) {
					self.slider.slick('slickGoTo', args, true);
				}
			}
		}
	}
};

var fileUpload = {
	formatFileSize: function(bytes) {
		if (typeof bytes !== 'number') {
			return '';
		}
		if (bytes >= 1000000000) {
			return (bytes / 1000000000).toFixed(1) + '&nbsp;Гб';
		}
		if (bytes >= 1000000) {
			return (bytes / 1000000).toFixed(1) + '&nbsp;Мб';
		}
		return (bytes / 1000).toFixed(1) + '&nbsp;Кб';
	},
	createInput: function() {
		if ($('.js-form-data-upload-file').length) {
			$('.js-form-data-upload-file-label').on("click", function(e) {
				e.preventDefault();
				var $this = $(this);
				var parent = $this.closest('.js-form-data-upload-file');

				parent.children('input[type="file"]').trigger('click');
			});
		}
	},
	changeFile: function() {
		var self = this;

		$(document).on('change', '.form-data__file-input', function() {
			var $this = $(this),
				parent = $this.closest('.js-form-data-upload-file'),
				label = parent.find('.js-form-data-upload-file-label'),
				labelText = label.data('text'),
				files = this.files;

			if (files.length) {
				var file = files[0];
				var start = 0;

				clearInterval(progressAnimate);
				parent.removeClass('is-load').addClass('is-loading');
				var progressAnimate = setInterval(function() {
					if (start >= 100) {
						clearInterval(progressAnimate);
						parent.removeClass('is-loading').addClass('is-load');
						label.text(labelText);
					}
					start += 10;
				}, 50);
			}
		});
	},
	init: function() {
		this.createInput();
		this.changeFile();
	}
};

var formVal = {
	formEl: null,
	submitEl: '',
	validation: function(e) {
		var self = this;
		var $this = $(e.currentTarget);
		var isError = false;
		var params = {};
		var tmp, tmpName;
		var errorMessage;
		if (e.data.jForm) {
			self.formEl = $('form[name="' + e.data.jForm + '"]');
		}
		if (!self.formEl.find('input[name="agreement"]').prop('checked') && $this.hasClass('disabled')) {
			return false;
		}
		errorMessage = self.formEl.find('.js-error-message');
		self.formEl.find('.js-requere').each(function() {
			tmp = $(this);
			tmpName = tmp.attr('name');
			if (tmpName) {
				if (tmpName != 'receipt') {
					params[tmpName] = tmp.val().trim();
				} else {
					params[tmpName] = tmp[0].files[0]
				}
			}
			if (tmpName == 'user_name') {
				if (Utilities.trimSpace(tmp.val()) === '') {
					if (tmp.val() == '	') {
						tmp.val('');
					}
					tmp.parent().addClass('is-error');
					isError = true;
					return false;
				}

				if (tmp.val().length < 2) {
					tmp.parent().addClass('is-error');
					isError = true;
					return false;
				}

				if ((!Utilities.TextValidateRu(tmp.val()) || Utilities.TextValidateEng(tmp.val())) &&
					(Utilities.TextValidateRu(tmp.val()) || !Utilities.TextValidateEng(tmp.val()))) {
					tmp.parent().addClass('is-error');
					isError = true;
					return false;
				}

				tmp.parent().removeClass('is-error');
				isError = false;
			}

			if (tmpName === 'user_email') {
				if (Utilities.trimSpace(tmp.val()) === '') {
					tmp.parent().addClass('is-error');
					isError = true;
					return false;
				}

				if (!Utilities.EmailValidate(tmp.val())) {
					tmp.parent().addClass('is-error');
					isError = true;
					return false;
				}
				tmp.parent().removeClass('is-error');
				isError = false;
			}

			if (tmpName === 'user_phone') {
				if (Utilities.trimSpace(tmp.val()) === '') {
					tmp.parent().addClass('is-error');
					isError = true;
					return false;
				}
				tmp.parent().removeClass('is-error');
				isError = false;
			}

			if (tmpName === 'receipt') {
				if (typeof(tmp[0].files[0]) === "undefined") {
					tmp.parent().addClass('is-error');
					isError = true;
					return false;
				}
				tmp.parent().removeClass('is-error');
				isError = false;
			}
		});

		if (isError) {
			if (!errorMessage.hasClass('is-error')) {
				errorMessage.addClass('is-error');
			}
		} else {
			errorMessage.removeClass('is-error');
			params["lending_name"] = self.formEl.find('input[name="lending_name"]').val();
			params["agreement"] = self.formEl.find('input[name="agreement"]').val();

			var formData = new FormData();
			for (var ops in params) {
				formData.append(ops, params[ops])
			}

			$.ajax({
				url: self.formEl.attr('action'),
				data: formData,
				type: 'POST',
				dataType: 'json',
				contentType: false,
				processData: false,
				success: function(json) {
					if (json.result == true) {
						self.formEl[0].reset();
						self.formEl.find('.is-load').removeClass('is-load');
						self.formEl.find('.js-submit').addClass('disabled');
						UI.Popup.open("024");
					} else {
						for (var i = 0; i < json.errors.length; i++) {
							console.log('error= ', json.errors[i].code);
							var el = self.formEl.find('[name="' + json.errors[i].code + '"]');
							el.parent().addClass('is-error');
							if (json.errors[i].code == "authorization") {
								UI.Popup.open("02");
							}
						}
					}
				}
			});
		}
	},
	init: function() {
		var self = this;
		var form = '';
		self.submitEl = $('.js-submit');
		form = self.submitEl.closest('form').attr('name');
		$('form[name="' + form + '"]').find('input[name="agreement"]').on('change', function() {
			$('form[name="' + form + '"]').find('.js-submit').toggleClass('disabled');

			if ($(this).prop('checked')) {
				$(this).val('y');
			} else {
				$(this).val('');
			}
		});
		self.submitEl.on('click', {
			jForm: form
		}, self.validation);
	}
}

$(function() {
	stepsSlider.init();
	rewardSlider.init();
	frame.init();
	scrollToElement.init();
	fileUpload.init();

	var gotoSlide = 0;
	$(document).on('click', '*[data-popup-open]', function(e) {
		e.preventDefault();
		gotoSlide = $(this).data('index');
		UI.Popup.open($(this).data('popup-open'));
	});

	UI.Popup.methods.rimmelPopupVideo = function() {
		popupVideoSlider.init(gotoSlide);
	};

	window['removePopupVideoSlider'] = function() {
		popupVideoSlider.destroy();
	};

	UI.Popup.methods.rimmelPopupResult = function() {
		popupResultSlider.init(gotoSlide);
	};

	window['removePopupResultSlider'] = function() {
		popupResultSlider.destroy();
	};

	if (typeof($.fn.mask) != "undefined" && $('.js-form-data-phone').length) {
		$(".js-form-data-phone").mask("+7 (999) 999-99-99");
	}

	formVal.init();
});
